import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_USERS,
  REQUEST_CREATE_MASTER_USERS,
  SET_MASTER_USERS,
  SUCCESS_CREATE_MASTER_USERS,
  ERROR_GET_MASTER_USERS,
  ERROR_CREATE_MASTER_USERS,
  SUCCESS_DELETE_MASTER_USERS,
  SUCCESS_UPDATE_MASTER_USERS,
  REQUEST_DELETE_MASTER_USERS,
  REQUEST_UPDATE_MASTER_USERS,
  ERROR_DELETE_MASTER_USERS,
  ERROR_UPDATE_MASTER_USERS,
} from "./userstActionTypes";

function* requestMasterUsers(action: Record<string, any>): any {
  try {
    const result: any = yield call(getUsersMaster);
    yield put({ type: SET_MASTER_USERS, payload: result.data.data });
    // console.warn(result.data.data, "jhuihihi");
    // console.log(result, "resulttt");
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_USERS, payload: message });
  }
}

function* requestUpdateMasterTagUsers(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterUsers,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_USERS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_USERS, payload: message });
  }
}

function* requestDeleteMasterTagUsers(action: Record<string, any>): any {
  try {
    yield call(deleteMasterUsers, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_USERS,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_USERS, payload: message });
  }
}

function* requestCreateMasterUsers(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterUsers, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_USERS,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_USERS, payload: message });
  }
}
export function getUsersMaster() {
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;

  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/user`,
    // url: `${process.env.REACT_APP_BASE_URL}/admin/user?date="${formattedDate}"`,
    //withCredentials: true,
  });
}

export function createMasterUsers(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/restaurant`,
    data: payload,
    //withCredentials: true,
  });
}

export function deleteMasterUsers(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/user/${_id}`,
    //withCredentials: true,
  });
}
export function updateMasterUsers(payload: Record<string, any>, _id: string) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/user/${_id}`,
    data: payload,
    //withCredentials: true,
  });
}

const usersMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_USERS, requestMasterUsers),
    takeLatest(REQUEST_CREATE_MASTER_USERS, requestCreateMasterUsers),
    takeLatest(REQUEST_UPDATE_MASTER_USERS, requestUpdateMasterTagUsers),
    takeLatest(REQUEST_DELETE_MASTER_USERS, requestDeleteMasterTagUsers),
  ]);
};

export default usersMasterSaga;
